import gql from 'graphql-tag';

export default gql`
  mutation deleteAdminUser($id: Int!) {
    deleteAdminUser(id: $id)
  }
`;
